/**
 * formatToken — Render queue token with optional appointment number.
 *
 * Token format:
 *   • Regular visit:     "#30"
 *   • Appointment visit:  "#30#1"   (token 30, appointment 1)
 *
 * @param {number|string} queueNumber  — Queue/token number
 * @param {number|string|null} appointmentNumber — Appointment day-sequence (optional)
 * @param {object} [opts]
 * @param {boolean} [opts.hash=true] — Prefix with '#'
 * @returns {string}
 */
export function formatToken(queueNumber, appointmentNumber, opts = {}) {
  const { hash = true } = opts;
  const prefix = hash ? '#' : '';
  const qn = queueNumber ?? '';
  if (appointmentNumber != null && appointmentNumber !== '' && appointmentNumber !== 0) {
    return `${prefix}${qn}#${appointmentNumber}`;
  }
  return `${prefix}${qn}`;
}

/**
 * Check if a visit object has appointment data.
 * @param {object} visit
 * @returns {boolean}
 */
export function isAppointmentVisit(visit) {
  return !!(visit && visit.appointment_number);
}
